
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wer kennt das nicht: Man kann nicht einschlafen oder wacht plötzlich in der Nacht auf, und die Gedanken beginnen im Kopf zu kreisen: Der Streit mit dem Freund, das anstehende Gespräch mit der Chefin – was tagsüber noch lösbar schien, wirkt plötzlich so kompliziert, so erdrückend. Warum ist das so? «Epidemiologische Studien zeigen, dass nächtliche Sorgen weit verbreitet sind», sagt Joe Hättenschwiler vom Zentrum für Angst- und Depressionsbehandlung Zürich (ZADZ). Dafür gibt es unter anderem hormonelle Gründe: Am frühen Morgen zwischen 3 und 4 Uhr arbeitet der Körper auf Sparflamme – viele von uns befinden sich in tiefem Schlaf. Das Hormon Melatonin wird dann vom Körper vermehrt ausgeschüttet, wir sind im Ruhemodus und entspannt. Sind wir dann allerdings wach, sinke infolge erhöhter Melatoninkonzentration die Laune, sagt Hättenschwiler. `}<br /><br />{`
Eine andere Erklärung könnte sein, dass uns die Dunkelheit oder gar die Einsamkeit in den Nächten mehr zu schaffen macht. Während wir tagsüber aktiv sind, haben wir in schlaflosen Nächten Zeit zum Grübeln. Dauert der nächtliche Spuk länger als ein paar Minuten, sollte man ein gedämpftes Licht einschalten oder aufstehen. Auch die Tatsache, dass man in den meisten Fällen weiss, dass die Laune am Morgen wieder besser sein wird, könnte helfen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;